import { Trans } from "@lingui/solid/macro";
import { ServerMember, User } from "stoat.js";

import { timeLocale, useTime } from "@revolt/i18n";

import { Text } from "../../design";

import { ProfileCard } from "./ProfileCard";

export function ProfileJoined(props: { user: User; member?: ServerMember }) {
  const dayjs = useTime();

  // Majalis: one "Member since" entry instead of two near-identical ones
  const since = () =>
    dayjs(props.member?.joinedAt ?? props.user.createdAt).format(
      timeLocale()[1]
        .formats.L?.replace("MM", "MMM")
        .replaceAll("/", " ")
        .replaceAll("-", " "),
    );

  return (
    <ProfileCard>
      <Text class="title" size="large">
        <Trans>Member since</Trans>
      </Text>
      <Text>{since()}</Text>
    </ProfileCard>
  );
}
